import apiHandler from './apiHandler';

const { tenantRequest } = apiHandler;

function groups({ signal } = {}) {

  return tenantRequest('/groups/list/', {
    method: 'GET',
    reqAuth: true,
    signal,
  });

}

function createGroup({ body, signal } = {}) {

  return tenantRequest('/groups/create/', {
    reqAuth: true,
    method: 'POST',
    body,
    signal,
  });

}

export default { groups, createGroup };
